class ResourceFilter {
  private resource: string = '';
  private params: { filter: Record<string, any> };
  private resourceFilterMap = (params: { filter: any }): Record<string, any> => {
    const { filter } = params;
    return {
      ...ChatChannelResourceFilter(filter),
      ...TimetrackingSegmentsResourceFilter(filter),
    };
  };

  constructor(incomingResource: string, incomingParams: { filter: Record<any, any> }) {
    this.resource = incomingResource;
    this.params = incomingParams;
  }

  get raw() {
    return this.resourceFilterMap(this.params)[this.resource];
  }

  get stringified() {
    return JSON.stringify(this.resourceFilterMap(this.params)[this.resource] ?? this.params.filter);
  }
}

const ChatChannelResourceFilter = (filter: any) => {
  const emptyDefault: undefined = undefined;
  return {
    'chat-channels': {
      type: filter.type ? { equals: filter.type } : emptyDefault,
    },
  };
};

const TimetrackingSegmentsResourceFilter = (filter: any) => {
  const emptyDefault: undefined = undefined;

  if (filter.taskId) {
    return {
      'timetracking/segments': {
        taskId: filter.taskId,
      },
    };
  }

  if (filter.userId) {
    return {
      'timetracking/segments': {
        userId: filter.userId,
      },
    };
  }

  return {
    'timetracking/segments': emptyDefault,
  };
};

export default ResourceFilter;
